<script>
export default {
  name: 'UlFormSelect',
  props: {
    value: {
      type: Object,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    query: '',
    max: 100,
  }),
  computed: {
    viewValue() {
      if (!this.value) {
        return false;
      }
      if (this.options.find(i => i.value === this.value.value)) {
        return false;
      }
      return true;
    },
    opts() {
      if (!this.remote) {
        return this.options;
      }
      if (this.query) {
        const query = this.query.toUpperCase();
        return this.options
          ?.filter(i => i.label.toUpperCase()
            .indexOf(query) >= 0) || [];
      }
      return this.options || [];
    },
    items() {
      return this.opts?.slice(0, this.max) || [];
    },
    remote() {
      return this.options?.length > this.max;
    },
    filterable() {
      return this.options?.length > 10;
    },
  },
  methods: {
    input(e) {
      this.$emit('input', e || null);
    },
    remoteMethod(query) {
      this.query = query;
    },
  },
};
</script>
<template>
  <el-select
    :value="value ? value: ''"
    class="ul-form-select"
    :clearable="clearable"
    :disabled="disabled"
    :filterable="filterable"
    :placeholder="placeholder"
    :remote="remote"
    :remote-method="remoteMethod"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="input"
    @change="$emit('change', $event)"
    popper-class="ul-form-select-popper"
  >
    <el-option
      v-if="loading"
      label="Загрузка..."
      :value="'Загрузка...'"
      disabled
    >
    </el-option>
    <el-option
      v-if="viewValue"
      :label="value.label"
      :value="value">
    </el-option>
    <el-option
      v-for="item in items"
      :key="item.value"
      :label="item.label"
      :value="item">
    </el-option>
    <el-option
      v-if="remote && opts.length > this.max"
      :label="`Всего: ${opts.length}`"
      :value="'------'"
      disabled
    >
    </el-option>
  </el-select>
</template>
<style lang="scss">
  .ul-form-select {
    width: 100%;
    position: relative;
    overflow: hidden;

    &.el-select .el-input {
      display: flex;
    }

    .el-input__inner {
      background: none!important;
      border: none;
      height: 28px;
      font-size: 16px;
      padding: 0 !important;
      flex-grow: 1;
    }

    .el-input__suffix {
      cursor: pointer;
      position: static;
      display: block;
      height: 28px;
      border-radius: 50%;
      width: 28px;
      color: #333333;


      .el-select__caret {
        color: #333333;
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  .el-input.is-disabled .el-input__inner {
    cursor: default;
  }

  .ul-form-select-popper {
    &.el-popper {
      margin: 0 !important;

      &[x-placement^=top] {
        border-radius: 4px 4px 0 0;
      }

      &[x-placement^=bottom] {
        border-radius: 0 0 4px 4px;
      }
    }

    .popper__arrow {
      display: none !important;
    }

    .el-select-dropdown__item {
      font-size: 16px;
    }


    .el-select-dropdown__item.selected {
      background-color: #1b2f3f;
      color: #fff;
    }

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover {
      background-color: #1b2f3fdd;
      color: #fff;
    }

    .el-scrollbar__bar.is-vertical {
      opacity: 1;

      .el-scrollbar__thumb {
        background: #1b2f3fdd;
      }
    }
  }
</style>
